"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  menu: 1000,
  appBar: 1100,
  drawerOverlay: 1200,
  drawer: 1300,
  dialogOverlay: 1400,
  dialog: 1500,
  layer: 2000,
  popover: 2100,
  snackbar: 2900,
  tooltip: 3000
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/styles/zIndex.js
 ** module id = 305
 ** module chunks = 0
 **/